var map = {
	"./app.svg": 8373,
	"./arrow-bottom.svg": 9767,
	"./bank.svg": 9449,
	"./box-white.svg": 5649,
	"./building-white.svg": 3146,
	"./building-with-annex.svg": 1218,
	"./building-with-tree.svg": 6070,
	"./building.svg": 6484,
	"./burger-menu.svg": 193,
	"./chevron-down.svg": 5762,
	"./chevron-up.svg": 5808,
	"./command.svg": 2077,
	"./court-house.svg": 1143,
	"./cross.svg": 5193,
	"./edit-pen.svg": 1121,
	"./eye-slash.svg": 3402,
	"./heart.svg": 2542,
	"./judge-gavel-white.svg": 6212,
	"./money.svg": 2590,
	"./monitor-white.svg": 8063,
	"./plug-white.svg": 7224,
	"./question-in-circle.svg": 1736,
	"./shield-tick.svg": 5091,
	"./shop.svg": 1100,
	"./square-steps-white.svg": 4912,
	"./support-24.svg": 4601,
	"./teacher.svg": 3327,
	"./triangle-white.svg": 6185
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6611;